import { UserPasswordInput as UIInput } from '@flippingbook/web.react-kit/dist/UserPasswordInput';
import cx from 'classnames';
import { forwardRef } from 'react';

import { b } from './style.css';

type UIInputProps = React.ComponentPropsWithoutRef<typeof UIInput>;

export const UserPasswordInput = forwardRef<HTMLInputElement, UIInputProps>(function Input(props, ref) {
    return (
        <UIInput
            {...props}
            ref={ref}
            className={cx(props.className, b.name)}
        />
    );
});
